import {
	DataMipTct,
	GetInvestmentProgrammeByPersonIdDto,
	GetInvestmentProgrammeByPersonIdRes,
} from '@dealstack/shared/lib/generated';
import { makeRequest } from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer.ts';
import { HTTP_METHOD } from '@dealstack/shared/lib/common/dataExchange/common.ts';
import * as ApiV1 from '@dealstack/shared/lib/common/dataExchange/apiV1.ts';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const getInvestmentProgrammeByDealId = async (endpoint: string) => {
	return await makeRequest<ApiV1.Response<DataMipTct[]>>({
		endpoint,
		method: HTTP_METHOD.GET,
	}).then((response) => response.payload as DataMipTct[]);
};

export const getMipsForPersonByDate = async (body: GetInvestmentProgrammeByPersonIdDto) => {
	return await makeRequest<ApiV1.Response<GetInvestmentProgrammeByPersonIdRes[]>>({
		endpoint: API_PATHS.MIP_PERSON_MIPS_POST,
		method: HTTP_METHOD.POST,
		body: JSON.stringify(body),
	}).then((response) => response.payload);
};
